export interface AdminImageThemeSelectionItem {
  code: string;
  status: string;
}

export function imageThemesForLab<T extends AdminImageThemeSelectionItem>(
  themes: readonly T[] | undefined,
): T[] {
  return (themes || []).filter((theme) => theme.status !== "deleted");
}
